<template>
  <div>
    <div
      h="9"
      flex="~ 1 items-center"
      b="~ 1 solid #777474"
      rounded="full"
      bg="#F3F3F3"
      p="x-4"
      @click="showDatePopup = true"
    >
      <img :width="21" src="~assets/icons/icon-calendar.png" />
      <div class="ml-2 text-sm text-[#777474]">
        {{ formatDate }}
      </div>
    </div>
    <BaseAZCalendar
      v-model:show="showDatePopup"
      :default-selected-date="defaultSelectedDate"
      @confirm="onConfirmCalendar"
    />
  </div>
</template>

<script lang="ts" setup>
import { ENUM_EventType, ENUM_PageName } from '~/enums'
import type { SearchDateClicksClickEvent } from '~/types/event-tracking'

const props = withDefaults(defineProps<Props>(), {
  formatter: 'DD MMM, YYYY',
  isDetail: false,
  attrName: '',
})

interface Props {
  formatter?: string
  isDetail?: boolean
  pageType?: string
  attrName?: string
}

const dayjs = useDayjs()
const gtm = useGtm()

const { locale } = useLocale()
const { showDatePopup } = useUseHomePopup()
const { query } = useRoute()
const filterStore = useFilterConditionsStore()
const { filterParams, getExperienceDetail } = useExperienceDetail()
const { attrId } = useAttractionDetail()

const selectDate = computed(() => {
  return dayjs(filterParams.value.travelDate).format('YYYY-MM-DD')
})

const formatDate = computed(() => {
  return selectDate.value ? dayjs(selectDate.value).format(props.formatter) : ''
})

const defaultSelectedDate = computed(() => {
  return new Date(selectDate.value || '')
})

function onConfirmCalendar(value: string) {
  filterParams.value.travelDate = dayjs(value).format('YYYY-MM-DD')
  getExperienceDetail()
  trackSearchDateClick()
}

function trackSearchDateClick() {
  const eventParams: SearchDateClicksClickEvent = {
    event: ENUM_EventType.SearchDateClick,
    page_category: props.isDetail ? ENUM_PageName.Detail : (props.pageType === 'home' ? ENUM_PageName.Home : ENUM_PageName.List),
    city: filterStore.filterConditions.selectedCity?.destinationName,
    city_id: filterStore.filterConditions.selectedCity?.destinationId,
    country_code: filterStore.filterConditions.selectedCity?.countryCode,
    search_date: dayjs(filterStore.filterConditions.date).format('YYYY-MM-DD'),
    locale: locale.value,
    campaign_id: query.campaign_id as string ?? '',
    campaign_name: query.campaign_name as string ?? '',
    attraction_id: props.isDetail ? `${attrId.value}` : '',
    attraction_name: props.isDetail ? props?.attrName ?? '' : '',
  }
  gtm?.trackEvent(eventParams)
}
</script>
